import React from 'react';
import { getAssetUrl } from '../../utils/assetUrl';

interface CmsHomePageTimelineStat {
  heading: string;
  body: string;
}

interface CmsHomePageTimelineData {
  name?: string;
  component?: string;
  heading?: string;
  sub_heading?: string;
  features: CmsHomePageTimelineStat[];
  background_color?: string;
}

interface CmsHomePageTimelineProps {
  data: CmsHomePageTimelineData;
}

export const CmsHomePageTimeline: React.FC<CmsHomePageTimelineProps> = ({ data }) => {
  return (
    <section className={`relative w-full py-800 px-500 overflow-hidden bg-[#0054A4]`}>
      {/* Decorative paw prints scattered across the background */}
      <img
        src={getAssetUrl('unauth/Cat-Paw.png')}
        alt=""
        className="absolute -top-[8px] left-[65px] h-12"
      />
      <img
        src={getAssetUrl('unauth/Cat-Paw.png')}
        alt=""
        className="absolute top-[90px] left-[60px] h-12"
      />
      <img
        src={getAssetUrl('unauth/Cat-Paw.png')}
        alt=""
        className="absolute bottom-[355px] -right-2 h-12 -scale-x-100"
      />
      <img
        src={getAssetUrl('unauth/Cat-Paw.png')}
        alt=""
        className="absolute bottom-[210px] -right-3 h-12 -scale-x-100"
      />
      <img
        src={getAssetUrl('unauth/Cat-Paw.png')}
        alt=""
        className="absolute bottom-[26px] right-[74px] h-12 -scale-x-100"
      />
      <img
        src={getAssetUrl('unauth/Cat-Paw.png')}
        alt=""
        className="absolute bottom-[152px] right-[90px] h-12 -scale-x-100"
      />

      <div className="relative z-10 mx-auto max-w-7xl">
        {data.name && (
          <div className="text-center mb-500">
            <h2 className="text-heading-200 font-semibold text-white max-w-[500px] mx-auto">
              {data.name}
            </h2>
          </div>
        )}

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 place-items-center">
          {data.features?.map((feature) => (
            <div key={`timeline-${feature.heading}`} className="text-center w-full max-w-[400px]">
              <div className="mb-3">
                <h2
                  className="font-bold text-white text-heading-400 leading-[1.13] tracking-[-0.03em]"
                  dangerouslySetInnerHTML={{ __html: feature.heading }}
                />
              </div>
              <div
                className="text-base md:text-lg text-white font-medium"
                dangerouslySetInnerHTML={{ __html: feature.body }}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CmsHomePageTimeline;
